import { API_BASE } from 'shared/constants/Api'

export const RECOVERY = `${API_BASE}/api/v2/ident-service/auth/password`
export const RESET_PASSWORD = `${API_BASE}/api/v2/ident-service/auth/password`
export const RESET_LINK_CHECK = `${API_BASE}/api/v2/ident-service/auth/password/edit`
